module.exports = __webpack_public_path__ + "static/realtor-slack-comment2-57073e7ddde6067da425cd3f2456b49e.png";